import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

export const SixDoorContent: React.FC<TDoor> = props => {
  return (
    <DoorContent btnText="Пройти тест и получить видео" {...props}>
      <div>
        <b>🎥 Специальный подарок для вашего роста</b>
      </div>
      <div>
        Сегодняшний подарок — эксклюзивная запись эфира Циан.Студии с Татьяной Рисованной, налоговым консультантом и
        юристом. В нём — важные инсайты про налоговую реформу, которая вступит в силу в 2026 году.
      </div>
      <div>
        <div>
          <b>Но сначала — небольшой вызов! </b>
        </div>
        <div>
          Пройдите наш короткий познавательный тест и проверьте, насколько хорошо вы знаете факты из рынка недвижимости.
          Это займёт всего пару минут 🎁
        </div>
      </div>
      <div>
        <i>Пусть этот подарок станет ещё одним шагом к вашим профессиональным высотам в 2026 году! 🚀</i>
      </div>
    </DoorContent>
  );
};
